import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["autoFocus", "ref"];
import React from 'react';
import { useForkRef } from "../ref.mjs";
function notUsingNativeAutoFocus(autoFocus) {
  return typeof autoFocus === 'boolean' || typeof autoFocus === 'number';
}

/** @deprecated */

function autoFocusEnhance() {
  return function (props) {
    var autoFocus = props.autoFocus,
      ref = props.ref,
      other = _objectWithoutProperties(props, _excluded);
    if (!notUsingNativeAutoFocus(autoFocus)) {
      return props;
    }
    var nodeRef = /*#__PURE__*/React.createRef();
    React.useEffect(function () {
      if (autoFocus === false) return;
      var inputNode = nodeRef.current;
      if (!inputNode || !inputNode.focus) return;
      var timer = setTimeout(function () {
        return inputNode === null || inputNode === void 0 ? void 0 : inputNode.focus();
      }, autoFocus || 0);
      return function () {
        clearTimeout(timer);
      };
    }, [autoFocus]);
    return _objectSpread({
      ref: useForkRef(ref, nodeRef)
    }, other);
  };
}
export default autoFocusEnhance;
//# sourceMappingURL=autoFocusEnhance.mjs.map